<template>
    <section class="panel-body">
        <div class="row">
            <div class="col-sm-8 col-md-6 col-lg-4">
                <div class="card card-outline card-outline-tabs" :class="appLayout.card">
                    <div class="card-header p-0 border-bottom-0">
                        <div class="nav-tabs-custom" role="tabpanel">
                            <!-- Nav tabs -->
                            <ul class="nav nav-tabs" role="tablist">
                                <li role="presentation" class="nav-item">
                                    <a class="nav-link active" aria-controls="tabConta" role="tab" data-toggle="tab"
                                        href="#tabConta"><i class="fa fa-cogs"></i>
                                        Conta</a>
                                </li>
                                <li role="presentation" class="nav-item">
                                    <a class="nav-link" aria-controls="tabTwofactor" role="tab" data-toggle="tab"
                                        href="#tabTwofactor"><i class="fa fa-shield"></i>
                                        Segurança</a>
                                </li>
                            </ul>
                        </div>
                        <!-- Tab panes -->
                        <div class="card-body">
                            <!-- Profile Image -->
                            <div class="tab-content">
                                <div role="tabpanel" class="tab-pane active" id="tabConta">
                                    <div class="box-body box-profile text-center">
                                        <img class="img-circle elevation-2" width="60px" alt="User Image"
                                            :src="auth_user.avatar">
                                        <h3 class="profile-username">{{ auth_user.name }}</h3>
                                        <hr>
                                        <button type="button" @click="prepareModalPassword()"
                                            class="btn btn-default btn-block">
                                            <i class="fa fa-lock"></i>
                                            {{$t('words.change_password')}}
                                        </button>
                                    </div>
                                </div>
                                <div role="tabpanel" class="tab-pane" id="tabTwofactor">
                                    <form-two-factory></form-two-factory>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- /.box -->
            </div>
            <div class="col-sm-12 col-lg-8">
                <div class="card card-outline card-outline-tabs" :class="appLayout.card">
                    <div class="card-header p-0 border-bottom-0">
                        <div class="nav-tabs-custom" role="tabpanel">
                            <!-- Nav tabs -->
                            <ul class="nav nav-tabs" role="tablist">
                                <li role="presentation" class="nav-item">
                                    <a class="nav-link active"><i class="fa fa-user"></i>
                                        {{ $t('words.basic_data')}}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!-- Tab panes -->
                    <div class="card-body">
                        <!-- INICIO TAB PESSOAL -->
                        <div class="tab-pane active" id="tabPersonal">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group" :class="{'is-invalid': errors.has('name')}">
                                        <label>{{ $t('attributes.name')}}</label>
                                        <input name="name" v-model="auth_user.name"
                                            v-validate="{required: true, max:120}" type="text" class="form-control"
                                            :placeholder="$t('words.type_social_name')">
                                        <div class="invalid-feedback help-block error">{{errors.first('name')}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group" :class="{ 'is-invalid': errors.has('document') }">
                                        <label>{{ $t('attributes.document')}}</label>
                                        <the-mask disabled name="document" v-model="auth_user.document"
                                            v-validate="{required: true, min:11, max:14}" class="form-control"
                                            type="text" :placeholder="$t('words.type_document')"
                                            :mask="['###.###.###-##', '##.###.###/####-##']" />
                                        <div class="invalid-feedback help-block error">
                                            {{errors.first('document')}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group" :class="{'is-invalid': errors.has('email')}">
                                        <label>{{ $t('attributes.email')}}</label>
                                        <input disabled name="email" v-model="auth_user.email" class="form-control">
                                        <div class="invalid-feedback help-block error">
                                            {{errors.first('born_date')}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group" :class="{'is-invalid': errors.has('phone')}">
                                        <label>{{ $t('attributes.phone')}}</label>
                                        <input name="phone" v-model="auth_user.phone" type="text" class="form-control"
                                            v-mask="['(##)####-####', '(##)#####-####']"
                                            :placeholder="$t('words.type_phone')">
                                        <div class="invalid-feedback help-block error">{{errors.first('phone')}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group" :class="{'is-invalid': errors.has('birth_date')}">
                                        <label>Nascimento</label>
                                        <input name="birth_date" v-model="auth_user.birth_date" type="date" class="form-control"
                                            :placeholder="$t('words.type_birth_date')">
                                        <div class="invalid-feedback help-block error">{{errors.first('birth_date')}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-8">
                                    <div class="form-group" :class="{'is-invalid': errors.has('gender')}">
                                        <label>Gênero</label>
                                        <br>
                                        <p-radio :color="appLayout.check" v-model="auth_user.gender" name="gender"
                                            value="M">Masculino</p-radio>
                                        <p-radio :color="appLayout.check" v-model="auth_user.gender" name="gender"
                                            value="F">Feminimo</p-radio>
                                        <p-radio :color="appLayout.check" v-model="auth_user.gender" name="gender"
                                            :value="null">Não informar
                                        </p-radio>

                                        <div class="invalid-feedback help-block error">{{errors.first('gender')}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group"
                                        :class="{ 'is-invalid': errors.has('zip'), 'has-warning':errors.has('zip_404') }">
                                        <label>{{ $t('attributes.zip')}}</label>
                                        <label class="control-label validator float-right"
                                            :class="{hide:!errors.has('zip_label')}" for="inputError">
                                            <i
                                                :class="{'fa fa-times-circle-o': errors.has('zip'), 'fa fa-warning':errors.has('zip_404') }"></i>
                                            {{errors.first('zip_label')}}
                                        </label>
                                        <div class="input-group">
                                            <input class="form-control" @keypress.enter="searchZip"
                                                v-model="user.zip_code" name="zip" v-validate="'required|max:9'"
                                                :placeholder="$t('words.type_zip')" v-mask="'#####-###'" type="text" />
                                            <span class="input-group-btn">
                                                <button type="button" class="btn btn-default" @click="searchZip"
                                                    :title="$t('words.btn_search_zip')">
                                                    <span class="fa fa-search"></span>
                                                </button>
                                            </span>
                                        </div>
                                        <div class="invalid-feedback help-block error">{{errors.first('zip')}}
                                            {{errors.first('zip_404')}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group" :class="{ 'is-invalid': errors.has('address') }">
                                        <label>{{ $t('attributes.address')}}</label>
                                        <input name="address" v-model="user.street" v-validate="{required:true,max:120}"
                                            type="text" class="form-control" :placeholder="$t('words.type_address')">
                                        <div class="invalid-feedback help-block error">{{errors.first('address')}}</div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group" :class="{ 'is-invalid': errors.has('number') }">
                                        <label>{{ $t('attributes.number') }}</label>
                                        <input name="number" v-model="user.address_number" v-validate="{required:true,max:60}"
                                            type="text" class="form-control" :placeholder="$t('words.type_number')">
                                        <div class="invalid-feedback help-block error">{{errors.first('number')}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group" :class="{ 'is-invalid': errors.has('neighborhood') }">
                                        <label>{{ $t('attributes.neighborhood')}}</label>
                                        <input name="neighborhood" v-model="user.neighborhood"
                                            v-validate="{required:true,max:60}" type="text" class="form-control"
                                            :placeholder="$t('words.type_neighborhood')">
                                        <div class="invalid-feedback help-block error">{{errors.first('neighborhood')}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group" :class="{ 'is-invalid': errors.has('state') }">
                                        <label>{{ $t('attributes.state')}}</label>
                                        <select name="state" @change="getCidades(user.state, user, 'user.empresa_ibge')"
                                            v-model="user.state" v-validate="{required:true}"
                                            :data-error="$t('validation.require_select')" class="form-control">
                                            <option :value="null">{{ $t('words.select')}}</option>
                                            <option v-for="(item, i) in estados" :value="item.id" :key="i">{{item.name}}
                                            </option>
                                        </select>
                                        <div class="invalid-feedback help-block error">{{errors.first('state')}}</div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group" :class="{ 'is-invalid': errors.has('city') }">

                                        <label>{{$tc('attributes.city', 1)}}</label>
                                        <select v-model="user.city" @change="getCidadeName()"
                                            :disabled="user.state === null" name="city" v-validate="{required:true}"
                                            class="form-control">
                                            <option :value="null">{{ $t('words.select')}}</option>
                                            <option v-for="(item, i) in cidades" :value="item.id" :key="i">{{item.name}}
                                            </option>
                                        </select>
                                        <div class="invalid-feedback help-block error">{{errors.first('city')}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group" :class="{ 'is-invalid': errors.has('complement') }">
                                        <span class="invisible">

                                        </span>
                                        <label>{{ $t('attributes.complement')}}</label>
                                        <input name="complement" v-model="user.complement"
                                            v-validate="{required:false,max:60}" type="text" class="form-control"
                                            :placeholder="$t('words.type_complement')">
                                        <div class="invalid-feedback help-block error">{{errors.first('complement')}}
                                        </div>
                                    </div>
                                </div>
                                <button @click="saveProfile()" :disabled="loading" class="btn btn-success btn-block"> <i
                                        :class="loading ? 'fa-circle-o-notch fa-spin':  'fa fa-check'"></i> Salvar Perfil
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <m-change-password ref="modalPassword"></m-change-password>
    </section>
</template>

<script>
    import {
        TheMask
    } from 'vue-the-mask';
    import FormTwoFactory from './components/form-two-factory.vue';
    import MChangePassword from './components/m-change-password';
    export default {
        name: 'ProfilePage',
        components: {
            TheMask,
            MChangePassword,
            FormTwoFactory,
        },
        data() {
            return {
                loading: false,
                user: {},
                cidades: [],
            };
        },
        beforeMount() {
            this.allow = this.allow.bind(this);
            this.formatMoney = this.formatMoney.bind(this);
            this.user = this.auth_user;
            this.getCidades(this.user.state);
        },
        watch: {
            $route(data) {
                this.$destroy();
            }
        },
        methods: {
            saveProfile() {
                this.loading = true;
                this.$store.dispatch('saveProfile', this.user).then(response => {
                    toastr({
                        icon: response.status,
                        title: response.message
                    });
                }).catch(error => {
                    toastr({
                        icon: error.status,
                        title: error.message
                    });
                }).finally(() => {
                    this.loading = false;
                });
            },
            resetCity() {
                if (this.cidades.findIndex(item => item.id == this.user.city) == -1) {
                    this.user.city = null;
                }
                this.getEstadoUf();
            },
            getEstadoUf() {
                if (!this.user.state) {
                    return;
                }
                this.user.uf = this.estados.find(x => x.id == this.user.state).uf;
            },
            getCidadeName() {
                this.user.city = this.cidades.find(x => x.id == this.user.city).name;
            },
            alterLanguage() {
                this.$store
                    .dispatch('changeLanguage', this.auth_user.user_language)
                    .then(response => {
                        toastr({
                            icon: 'success',
                            title: response.message
                        });
                        this.$root.$i18n.locale = this.auth_user.user_language;
                        this.$root.$validator.locale = this.auth_user.user_language;
                    });
            },
            save() {
                this.$validator.validateAll(['name']).then(valid => {
                    if (valid) {
                        this.loading = true;
                        this.$store
                            .dispatch('updateUser', this.auth_user)
                            .then(response => {
                                if (response.status === 'success') {
                                    this.$store.commit('SET_USER_PERSONAL', this.auth_user);
                                    toastr({
                                        icon: response.status,
                                        title: response.message
                                    });
                                }
                                this.loading = false;
                            });
                    }
                });
            },
            cancel() {
                let obj = new Object();
                obj = _.cloneDeep(this.$store.state.user);
                this.auth_user = obj;
            },
            refreshPin() {
                this.$store
                    .dispatch('refreshUserPin')
                    .then(response => {
                        this.$store.commit('UPDATE_USER_PIN', response);
                        toastr({
                            icon: 'success',
                            title: 'Atualizado com sucesso!'
                        });
                    });
            },
            handdlePin() {
                this.hiddenPin = !this.hiddenPin;
            },
            prepareModalPassword() {
                this.$refs.modalPassword.prepareModalPassword();
            },
            searchZip() {
                if (this.user.zip_code != undefined) {
                    service.searchZip(this.user.zip_code)
                        .then(response => {
                            if (response.uf !== undefined) {
                                this.user.street = response.logradouro
                                this.user.neighborhood = response.bairro
                                this.user.state = response.ibge.substring(0, 2);
                                this.user.city = response.ibge
                                this.user.city_name = response.localidade;
                                this.user.uf = response.uf;
                                this.getCidades(this.user.state);
                                $('#Nro').focus();
                                this.validate();
                                this.getEstadoUf();
                                this.getCidadeName();
                            }
                        })
                        .catch(error => {
                            this.isLoadingCep = false;
                        });
                }
            },
        }
    };
</script>